export default (params) => ({
  trigger: {
    name: 'recommended_accessories.open_product_summary',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'recommended_accessories',
          'recommended_accessories_alternative_overlay',
        ],
      },
    },
    event: {
      name: 'select_content',
      params: {
        content: 'product_summary_overlay',
      },
    },
  },
});
